module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-112-retro-min.89851e84.jpg";